import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-efota-customer',
  templateUrl: './efota-customer.component.html',
  styleUrls: ['./efota-customer.component.scss']
})
export class EfotaCustomerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
